module.exports = __webpack_public_path__ + "img/20200905_150217.2522b7c6.jpg";